import { useActivePlanQuery } from "../../graphql/generated/graphql";
import LoadingButton from "../Button/LoadingButton";
import CardModal from "../Modal/CardModal";

interface PopupProps {
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  giftStatus: string;
  handleGiftConfirmation: () => void;
  loading: boolean;
  isRequired?: boolean;
}

const GiftPopup = ({
  isModalOpen,
  setIsModalOpen,
  giftStatus,
  handleGiftConfirmation,
  loading,
  isRequired = false,
}: PopupProps) => {
  const { data, loading: queryLoading, error } = useActivePlanQuery();

  const hasActivePlan = data?.invoices?.nodes?.some(
    (invoice) => invoice.status === "PAID"
  );

  if (!isRequired && (queryLoading || hasActivePlan)) {
    return null;
  }

  const handleGiftClick = async () => {
    if (queryLoading) {
      return;
    }

    if (error) {
      console.error("Error fetching active plan:", error);
      alert("خطا در بررسی پلن فعال. لطفاً دوباره تلاش کنید.");
      return;
    }

    try {
      await handleGiftConfirmation();
      setIsModalOpen(false);
    } catch (err) {
      console.error("Error confirming gift:", err);
      alert("خطا در ثبت هدیه. لطفاً دوباره تلاش کنید.");
    }
  };

  return (
    <CardModal
      open={isModalOpen}
      setOpen={(isOpen) => {
        if (!isRequired) {
          setIsModalOpen(isOpen);
        }
      }}
      request={giftStatus}
    >
      <div className="mx-auto my-auto">
        <h3 className="text-lg font-semibold mb-4 text-center">
          کمپین استودیو منابع انسانی کارجو پلاس
        </h3>
        <p className="text-sm text-gray-600 mb-4 text-center">
          برای دریافت این هدیه کافیست روی دکمه "دریافت هدیه" کلیک نمایید تا هدیه
          ثبت نام برای شما فعال شود
        </p>
        <div className="flex justify-between">
          <button
            onClick={handleGiftClick}
            className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-700 mx-auto shadow shadow-green-900"
            disabled={loading || queryLoading}
          >
            {loading || queryLoading ? <LoadingButton /> : "دریافت هدیه"}
          </button>
        </div>
      </div>
    </CardModal>
  );
};

export default GiftPopup;
